import React, { useEffect, useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { FaExternalLinkAlt } from "react-icons/fa";
import { NavLink, useLocation } from 'react-router-dom';
import { useSelectedFeatureContext } from '../contexts/SelectedFeatureContext';
import { IoIosLogOut } from "react-icons/io";
import { useUserContext } from '../contexts/UserContext';
import logo from "../assets/images/logo.png"

const NavbarMain = () => {
    const { selectedView, selectedFeatureName } = useSelectedFeatureContext();
    const [showMenu, setShowMenu] = useState(false);

    const handleToggle = () => {
        setShowMenu(!showMenu);
    };
    const { handleLogout, loginUser } = useUserContext();



    const handleLinkClick = () => {
        setShowMenu(false);
    };
    // const location = useLocation()
    // const collapseName = location.pathname.split("/")[1];



    return (
        <>
            <div className='navbar_main_container'>
                <div className='short_nav_container'>
                    <div className='main_nav_logo'>
                        {/* <img src={logo} alt='Logo'/> */}
                    </div>



                    <div className='logo_text'>
                        <h1>Nourish & Flourish</h1>
                    </div>

                    <div className={`main_nav ${showMenu ? 'show' : ''}`}>
                        <div className="nav__content">

                            <div className='nav__list'>
                                <NavLink
                                    className={({ isActive }) => (isActive ? 'active_nav' : 'nav__item')}

                                    to="/" onClick={handleLinkClick}>
                                    Map
                                </NavLink>

{/* <NavLink className={({ isActive }) => (isActive ? 'active_nav' : 'nav__item')}
                                    to="/fbs-wri" onClick={handleLinkClick}>
                                    fbs-wri
                                </NavLink> */}


                                <NavLink className={({ isActive }) => (isActive ? 'active_nav' : 'nav__item')}
                                    to="/info" onClick={handleLinkClick}>
                                    Info
                                </NavLink>



                            </div>

                        </div>
                    </div>

                    <div className="navbar__toggle scrolled" onClick={handleToggle}>
                        {showMenu ? <FaTimes /> : <FaBars />}
                    </div>

                </div>



            </div>
        </>



    )
}

export default NavbarMain
